import { render, ReactDOM } from 'react-dom';
import './index.css';
import * as React from 'react';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import { Aggregate, Group, AggregateDirective, AggregatesDirective, AggregateColumnsDirective, AggregateColumnDirective, DataStateChangeEventArgs, GridComponent, ColumnsDirective, ColumnDirective, Page, Filter, Inject } from '@syncfusion/ej2-react-grids';
import { Category, ChartComponent, ColumnSeries, DataLabel, Legend, LineSeries, SeriesCollectionDirective, SeriesDirective, Tooltip } from '@syncfusion/ej2-react-charts';
import { SampleBase } from './sample-base';
import { Browser } from '@syncfusion/ej2-base';
import axios from "axios";
import { Charts } from '../utils/chart';
import moment from "moment";


export class BlogPosts extends SampleBase {
    constructor(props) {
        super(...arguments);
        this.state = {
            data: [],
            Copydata: [],
            filteredData: [],
            loading: true
        };

        this.tooltip = { enable: true, shared: false };
        this.primaryyAxis = { labelFormat: '${value}' };
        this.primarxyAxis = { valueType: 'Category' };
        this.legendSettings = { visible: true };
        this.marker = { dataLabel: { visible: true } };


        this.filterType = [
            { text: 'Menu', value: 'Menu' },
            { text: 'Checkbox', value: 'CheckBox' },
            { text: 'Excel', value: 'Excel' },
        ];
        this.filterSettings = { type: 'Excel' };
        this.fields = { text: 'text', value: 'value' };
        this.format = { type: 'datetime', format: 'M/d/y hh:mm a' };
    }


    rowSelected(args) {
        console.log("In rowSelected");
        let data = this.gridInstance.getCurrentViewRecords();
        console.log("dataSelected", data);
        this.GridRefresh = true;
        this.setState({ filteredData: data });
    }

    loading = () => (
        <div className={this.state.loading ? 'ajax-loaded' : 'ajax-loading'}>LOADING...</div>
    );

    componentDidMount() {
        axios.get(`https://w5uiqzmyhg.execute-api.us-east-1.amazonaws.com/InAppAndroid/inappandroid`)
            .then(res => {
                const data = res.data;
                var index = 1;
                var units = 1;
                data.forEach(element => {
                    var date = new Date(element.datetime);
                    var price = 1; //for testing purpose. 
                    element.datetime = date;
                    var graphdate = moment(date).format('MMM Do');
                    element.datetimeForGraph = graphdate;
                    var version = (Math.random() * (0.20 - 0.21) + 0.20).toFixed(2);
                    element.version = version;
                    element.units = units;
                    element.price = price + index; //for testing purpose. 
                    index++;
                });
                this.setState({ data });
                this.setState({ Copydata: data });
                this.setState({ loading: false });
            })
            .then(res => {
				if (this.state.loading == false) {
					this.UniqueSum();
				}
			})
    }
    footerSum(props) {

		return (<div className='Sum'>{' Sales: '}{'$'}{props.Sum}</div>)
    }
    

    UniqueSum() {
		var sum = {}, result;
		var index = 0;
		// console.log("copyData:",this.state.Copydata );
		for (var i = 0, c; c = this.state.Copydata[i]; ++i) {
			if (undefined === sum[c['appItem']]) {
				index++;
				sum[c['appItem']] = c;
			}
			else {

				sum[c['appItem']]['price'] += c['price'];
                sum[c['appItem']]['units'] += c['units'];

			}
		}
		result = Object.keys(sum).map(function (val) { return sum[val] });
		console.log("result:", result);
		this.setState({ data: result });
    }
    
    render() {

        return (<div className='control-pane'>
            {this.loading()}
            <div className='control-section row'>
                <div className='GraphClass'>
                    <ChartComponent id="charts" primaryXAxis={this.primarxyAxis} chartArea={{ border: { width: 0 } }} width={Browser.isDevice ? '100%' : '90%'}  title='Android inApps purchases' legendSettings={this.legendSettings} primaryYAxis={this.primaryyAxis} tooltip={this.tooltip}>
                        <Inject services={[ColumnSeries, DataLabel, Tooltip, Legend, LineSeries, Category]} />
                        <SeriesCollectionDirective>
                            <SeriesDirective dataSource={this.state.filteredData} xName='datetimeForGraph' yName='price' name='InApp Purchase Analysis' marker={this.marker} />
                        </SeriesCollectionDirective>
                    </ChartComponent>
                </div>

                <GridComponent dataSource={this.state.data} dataBound={this.rowSelected.bind(this)} allowPaging={true} ref={grid => this.gridInstance = grid} pageSettings={{ pageSize: 10, pageCount: 5 }} allowFiltering={true} filterSettings={this.filterSettings}>
                    <ColumnsDirective>
                        <ColumnDirective field='studioID' headerText='Studio ID' width='130'></ColumnDirective>
                        <ColumnDirective field='version' headerText='Version' width='120' textAlign='left'></ColumnDirective>
                        <ColumnDirective field='appId' headerText='Name' width='150' textAlign='left'  allowFiltering={false} ></ColumnDirective>
                        <ColumnDirective field='datetime' headerText='Date' width='150' format={this.format} textAlign='left' />
                        <ColumnDirective field='appItem' headerText='App Item' width='150'></ColumnDirective>
                        <ColumnDirective field='device' headerText='Device' width='120' format='C2' textAlign='left' allowFiltering={false} />
                        {/* <ColumnDirective field='flag' headerText='Flag' width='110'></ColumnDirective> */}
                        {/* <ColumnDirective field='id' headerText='ID' width='150'></ColumnDirective> */}
                        {/* <ColumnDirective field='receiptData' headerText='Receipt Data' width='150'></ColumnDirective> */}
                        <ColumnDirective field='price' headerText='Sales' width='100'  allowFiltering={false} ></ColumnDirective>
						<ColumnDirective field='units' headerText='Units' width='100'  allowFiltering={false} ></ColumnDirective>
                    </ColumnsDirective>
                    <AggregatesDirective>
						<AggregateDirective>
							<AggregateColumnsDirective>
								<AggregateColumnDirective field='price' type='Sum' footerTemplate={this.footerSum} />
							</AggregateColumnsDirective>
						</AggregateDirective>
					</AggregatesDirective>
					<Inject services={[Filter, Page, Group, Aggregate]} />
                </GridComponent>
            </div>

        </div>);
    }
}

// render(<BlogPosts />, document.getElementById("root"));
export default BlogPosts;
